/**
 * ConditionRegistry — Singleton registry mapping condition names to boolean
 * evaluator functions. Used by CinematicDirector to evaluate `skipIf` on steps.
 *
 * Scenes register conditions at creation time (e.g., 'hasWalls', 'hasSpecialTiles').
 * Steps reference them by string key so cinematic JSON stays serializable.
 */

type ConditionEvaluator = () => boolean;

const conditions = new Map<string, ConditionEvaluator>();

export const ConditionRegistry = {
  /** Register a named condition with an evaluator function */
  register(key: string, evaluator: ConditionEvaluator): void {
    conditions.set(key, evaluator);
  },

  /** Remove a registered condition */
  unregister(key: string): void {
    conditions.delete(key);
  },

  /** Evaluate a condition by name. Returns false if key not found (never skip unknown). */
  evaluate(key: string): boolean {
    const evaluator = conditions.get(key);
    if (!evaluator) return false;
    return evaluator();
  },

  /** Get all registered condition keys */
  getKeys(): string[] {
    return Array.from(conditions.keys());
  },
};
